import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.sessionCache || initialState;

export const selectSessionCache = createSelector([selectSlice], state => state);
